var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgData(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 114,
    height: 117,
    viewBox: "0 0 114 117",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_727_1696)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.84961 47.0778L41.2827 74.5176L72.7166 54.7969L104.15 10.0215",
    stroke: "url(#paint0_linear_727_1696)",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.975 17.2633C112.428 13.8069 112.428 8.20288 108.975 4.74642C105.523 1.28997 99.9244 1.28997 96.4716 4.74642C93.0188 8.20288 93.0188 13.8069 96.4716 17.2633C99.9244 20.7198 105.523 20.7198 108.975 17.2633Z",
    fill: "url(#paint1_linear_727_1696)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.7053 62.6314C76.5865 62.6314 80.5435 58.6703 80.5435 53.784C80.5435 48.8977 76.5865 44.9365 71.7053 44.9365C66.8242 44.9365 62.8672 48.8977 62.8672 53.784C62.8672 58.6703 66.8242 62.6314 71.7053 62.6314Z",
    fill: "url(#paint2_linear_727_1696)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.2708 82.3521C45.1519 82.3521 49.1089 78.391 49.1089 73.5047C49.1089 68.6184 45.1519 64.6572 40.2708 64.6572C35.3896 64.6572 31.4326 68.6184 31.4326 73.5047C31.4326 78.391 35.3896 82.3521 40.2708 82.3521Z",
    fill: "url(#paint3_linear_727_1696)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.83815 54.9122C13.7193 54.9122 17.6763 50.9511 17.6763 46.0647C17.6763 41.1784 13.7193 37.2173 8.83815 37.2173C3.95698 37.2173 0 41.1784 0 46.0647C0 50.9511 3.95698 54.9122 8.83815 54.9122Z",
    fill: "url(#paint4_linear_727_1696)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.611 26.5909L94.3906 41.1495C94.3312 41.2333 94.2998 41.3338 94.2998 41.4369V115.427C94.2998 115.833 94.6279 116.161 95.0329 116.161H113.268C113.672 116.161 114.001 115.833 114.001 115.427V23.6093C114.001 23.1865 113.528 22.9768 113.198 23.2407C110.914 25.07 108.075 26.2135 104.973 26.3926C104.828 26.4014 104.694 26.4721 104.611 26.5909H104.611Z",
    fill: "url(#paint5_linear_727_1696)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.8672 115.427C62.8672 115.833 63.1953 116.161 63.6002 116.161H81.8349C82.2398 116.161 82.568 115.833 82.568 115.427V68.3823C82.568 67.9595 82.0958 67.7507 81.7668 68.0154C79.2823 70.0168 76.1485 71.2372 72.718 71.2372C70.9997 71.2372 69.3652 70.9096 67.8406 70.3505C67.7027 70.2998 67.5526 70.3147 67.4278 70.3924L63.1019 73.1067C62.9562 73.1984 62.8681 73.3583 62.8681 73.5304V115.427H62.8672Z",
    fill: "url(#paint6_linear_727_1696)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.4325 88.1029V115.427C31.4325 115.833 31.7606 116.161 32.1656 116.161H50.4002C50.8051 116.161 51.1333 115.833 51.1333 115.427V88.102C51.1333 87.6792 50.6612 87.4704 50.3322 87.7351C47.8468 89.7365 44.7121 90.9569 41.2816 90.9569C37.8511 90.9569 34.7182 89.7365 32.2328 87.736C31.9038 87.4713 31.4316 87.6801 31.4316 88.1029H31.4325Z",
    fill: "url(#paint7_linear_727_1696)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.84995 63.5189C6.42031 63.5189 3.28652 62.2985 0.801121 60.2971C0.47212 60.0324 0 60.2412 0 60.664V115.427C0 115.833 0.328128 116.161 0.733052 116.161H18.9677C19.3726 116.161 19.7008 115.833 19.7008 115.427V67.8791C19.7008 67.7349 19.6379 67.5969 19.5297 67.5026L14.3381 62.9703C14.2116 62.8602 14.0414 62.8244 13.8809 62.8734C12.598 63.2621 11.2602 63.5189 9.85082 63.5189H9.84995Z",
    fill: "url(#paint8_linear_727_1696)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_727_1696",
    x1: 56.9997,
    y1: 10.0215,
    x2: 56.9997,
    y2: 74.5176,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F89837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FECE72"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_727_1696",
    x1: 96.4716,
    y1: 4.74642,
    x2: 108.989,
    y2: 17.2502,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F89837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FECE72"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_727_1696",
    x1: 71.7053,
    y1: 44.9365,
    x2: 71.7053,
    y2: 62.6314,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F89837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FECE72"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_727_1696",
    x1: 40.2708,
    y1: 64.6572,
    x2: 40.2708,
    y2: 82.3521,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F89837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FECE72"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_727_1696",
    x1: 8.83815,
    y1: 37.2173,
    x2: 8.83815,
    y2: 54.9122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F89837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FECE72"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_727_1696",
    x1: 104.15,
    y1: 23.124,
    x2: 104.15,
    y2: 116.161,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F89837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FECE72"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_727_1696",
    x1: 72.7176,
    y1: 67.8979,
    x2: 72.7176,
    y2: 116.161,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F89837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FECE72"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_727_1696",
    x1: 41.2825,
    y1: 87.6177,
    x2: 41.2825,
    y2: 116.161,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F89837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FECE72"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_727_1696",
    x1: 9.85038,
    y1: 60.1797,
    x2: 9.85038,
    y2: 116.161,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F89837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FECE72"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_727_1696"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 114,
    height: 116,
    fill: "white",
    transform: "translate(0 0.161133)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgData);
export default __webpack_public_path__ + "static/media/Data.4b832aa78553bb9cc32dd442feb156c2.svg";
export { ForwardRef as ReactComponent };